<template>
  <section id="settings" class="is-fullheight">
    <Navigation></Navigation>
    <div class="has-padding-y has-margin-top-80">
      <div class="container">
        <!--
        <div class="columns">
          <div class="column">
            <div class="box has-content-background box-shadow-dark is-paddingless-y">
              <div class="card-content">
                <div class="content is-paddingless-y">
                  Tag Handle: <router-link to="/settings-taghandle">@{{ userProfile.taghandle }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="box has-content-background box-shadow-dark is-paddingless-y">
              <div class="card-content">
                <div class="content">
                  Payment Details <a href="">Edit</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        -->
        <div class="columns is-centered">
          <div class="column is-6">
            <div class="card-content">
              <h3 class="has-text-centered">{{ $t('settings.profile') }}</h3>
              <hr />
              <form @submit.prevent="validateBeforeSubmit">
                <b-field :label="lableType"
                  :type="{'is-danger': errors.has('name')}"
                  :message="errors.first('name')">
                  <b-input 
                    v-model.trim="fullName" 
                    :value="fullName"
                    v-validate="'required'"
                    name="name"
                    maxlength="20" 
                    type="text">
                  </b-input>
                </b-field>
                <b-field v-if="this.type != 'Business'" :label="$t('settings.form-label-position')">
                  <b-input 
                    v-model.trim="position" 
                    :value="position" 
                    maxlength="20" 
                    type="text" 
                    id="position">
                  </b-input>
                </b-field>
                <b-field :label="$t('settings.form-label-location')">
                  <b-input 
                    v-model.trim="location" 
                    :value="location" 
                    maxlength="20" 
                    type="text" 
                    id="location">
                  </b-input>
                </b-field>
                <!--<b-button @click="updateProfile" type="is-primary">Update Profile</b-button>-->
                <button type="submit" class="button is-primary-grad is-rounded is-fullwidth">{{ $t('settings.button-update-profile') }}</button>
              </form>
            </div>
          </div>
          <!--
          <div class="box bg-navy-dark box-shadow-dark is-paddingless-y">
            <div class="card-content">
              <div class="content">
                <p>Show Social (hidden)</p>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true">
      <div id="spinner"></div>
    </b-loading>
  </section>
</template>

<script>
import { mapState } from "vuex";
import Navigation from '@/components/Navigation'

export default {
  data() {
    return {
      /*
      fullName: "",
      position: "",
      location: "",
      localName: "",
      localPosition: "",
      localLocation: "",*/
      type: "",
      lableType: "",
      isLoading: false,
      isFullPage: "",
    };
  },
  components: {
    Navigation
  },
  computed: {
    ...mapState(["userProfile"]),
    /*
    localName: function () {
      //this.fullName = this.userProfile.name;
      return this.userProfile.name;
    },
    localPosition: function () {
      //this.fullName = this.userProfile.name;
      return this.userProfile.position;
    },
    localLocation: function () {
      //this.fullName = this.userProfile.name;
      return this.userProfile.location;
    }*/
  },
  
  beforeMount() {
    this.showUser()
  },
  
  methods: {
    showUser() {
      this.fullName = this.userProfile.name;
      this.position = this.userProfile.position;
      this.location = this.userProfile.location;
      this.type = this.userProfile.type;
      if (this.type == "Business"){
        this.lableType = this.$t("settings.business-name");
      } else {
        this.lableType = this.$t("settings.individual-name");
      }
      /*
      console.log("this.fullName: " + this.userProfile.name);
      console.log("this.position: " + this.userProfile.position);
      console.log("this.location: " + this.userProfile.location);
      */
    },
    
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true;
          this.updateProfile();
          return;
        }
        this.$toast.open({
          duration: 3000,
          message: this.$t("settings.toast-form-invalid"),
          position: "is-bottom",
          type: "is-danger"
        });
        this.scrollTo();
      });
    },

    updateProfile() {
      console.log("this.fullName: " + this.fullName);
      console.log("this.position: " + this.position);
      console.log("this.location: " + this.location);
      console.log("this.type: " + this.type);
      this.$store.dispatch("updateProfile", {
        name: this.fullName,
        position: this.position,
        location: this.location,
        type: this.type,
        //name: this.localName !== "" ? this.localName : this.userProfile.name,
        //position: this.position !== "" ? this.position : this.userProfile.position,
        //location: this.location !== "" ? this.location : this.userProfile.location,
      }).then(user => {
        this.snackbarSuccess();
        this.isLoading = false;
      }, error => {
        console.error("Got nothing from server: " + error)
        this.snackbarError();
        this.isLoading = false;
      })
    },

    scrollTo() {
      var element = '#settings';
      var duration = 300;
      var options = {
        easing: 'ease-in',
        offset: -80,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      this.$scrollTo(element, duration, options)
    },
    snackbarSuccess() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("settings.snackbar-success"),
        type: 'is-primary',
        position: 'is-bottom',
        actionText: this.$t("settings.snackbar-success-action"),
        class: 'has-background-info',
        queue: false,
        onAction: () => {
          this.$router.push("/posts");
        }
      })
    },
    snackbarError() {
      this.$snackbar.open({
        duration: 4000,
        message: this.$t("settings.snackbar-error"),
        type: 'is-info',
        position: 'is-bottom',
        actionText: this.$t("settings.snackbar-error-action"),
        queue: false,
        onAction: () => {
          this.$router.push("/posts");
        }
      })
    },
  },
};
</script>